var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{attrs:{"id":"gotohome"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[_c('img',{attrs:{"src":require("../assets/pagenotfound.png"),"alt":"img"}})])
}]

export { render, staticRenderFns }